import { PureComponent, Fragment } from "react";
import PictureComponent from "../picture/picture-component";
import { picOverlayStyles } from "./picture-with-overlay-component.scss";
import { fixDevImageUrl } from "/services/community/url-service";
import PicturePreviewComponent from "/components/core/picture-preview/picture-preview-component";
import MagnifyIcon from "/static/svg/community/magnifying_glass.svg";

export default class PictureWithOverlay extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      imgPreviewSrc: null
    };

    this.closeImagePreview = this.closeImagePreview.bind(this);
    this.openImagePreview = this.openImagePreview.bind(this);
  }

  closeImagePreview() {
    this.setState({ imgPreviewSrc: null });
  }

  openImagePreview(src) {
    let { overlayImage } = this.props;
    const { imgPreviewSrc } = this.state;
    if (imgPreviewSrc) {
      // already open - closing
      this.closeImagePreview();
    } else {
      this.setState({ imgPreviewSrc: overlayImage.src });
    }
  }

  renderOverlayImage(overlayImage) {
    const { imgPreviewSrc } = this.state;
    if (overlayImage) {
      if (overlayImage.src && overlayImage.src.length > 0) {
        let src = overlayImage.src;
        src = fixDevImageUrl(src);
        return (
          <div className="overlay-image-container">
            <MagnifyIcon className="zoom-in" />
            <PicturePreviewComponent src={imgPreviewSrc} closeCallback={this.closeImagePreview} />
            <img src={src} className={"overlay-image"} alt={overlayImage.alt} style={overlayImage.style} />
            <style jsx>{picOverlayStyles}</style>
          </div>
        );
      }
      return (
        <Fragment>
          <div
            className="overlay-image-text-only"
            style={overlayImage.styleTextOnly}
            dangerouslySetInnerHTML={{ __html: overlayImage.alt }}
          />
          <style jsx>{picOverlayStyles}</style>
        </Fragment>
      );
    }
    return null;
  }

  render() {
    let { overlayImage } = this.props;
    return (
      <div className="picture-with-overlay" onClick={this.openImagePreview}>
        <PictureComponent {...this.props} />
        {this.renderOverlayImage(overlayImage)}
      </div>
    );
  }
}
